/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

// The chat-agent selection id lives here, at the blackbolt (selector) tier, so
// provider-selection code (`agentProviderFlag`, `app.ts`) can name it WITHOUT
// importing `@/bedrockAgent` — that back-edge would birth a
// blackbolt ↔ bedrockAgent bi-reference (bedrockAgent already imports blackbolt).
// `bedrockConfig` re-exports this for the provider's own registration use.

/** Stable machine id the Bedrock chat-agent provider registers under (`?agent=bedrock`). */
export const BEDROCK_PROVIDER_ID = 'bedrock'

/**
 * The built-in claw default's id. Unlike bedrock it isn't a REGISTERED provider
 * (claw is statically wired as the fallback in `agentService`), but it needs a
 * name so the single provider preference can represent "use the default" as a
 * value rather than a null/absent special case.
 */
export const CLAW_PROVIDER_ID = 'claw'

/**
 * The closed set of chat-agent provider ids the preference can hold. `claw` is
 * the built-in default; `bedrock` is the registered alternative selected from
 * the debug settings radio group.
 */
export type AgentProviderId = typeof CLAW_PROVIDER_ID | typeof BEDROCK_PROVIDER_ID
